import {Component, Input, OnInit} from '@angular/core';
import {NzModalRef} from 'ng-zorro-antd';
import {ProductsService} from '../../../services';
import {ActivatedRoute, Router} from '@angular/router';
import moment from 'moment';
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";

@Component({
  selector: 'app-detail-product-passport',
  templateUrl: './detail-product-passport.component.html',
  styleUrls: ['./detail-product-passport.component.scss']
})
export class DetailProductPassportComponent implements OnInit {
  // @Input() urlImageProduct;
  // @Input() productName;
  // @Input() barcodeProduct;
  // @Input() productId;
  productId: any;
  productDetail: any;
  passports: any = [];
  activePassport = 0;
  passport: any;
  loading = false;
  detail: any;
  listPassportDocument: any = [];
  urlImageProduct: any;
  unsubscribe$ = new Subject<void>();

  constructor(private productsService: ProductsService,
              private router: Router,
              private productService: ProductsService,
              private route: ActivatedRoute) { }

  ngOnInit() {
    this.productId = this.route.snapshot.paramMap.get('id');
    this.route.queryParams.subscribe(params => {
      this.urlImageProduct = params.urlImageProduct;
    });
    this.productService
      .getById(this.productId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          if (res && res.code === 1) {
            this.productDetail = res.data || null
            this.loadPassport();
            this.loadData();
          }
        })
  }

  compare(a, b) {
    // So sánh theo createAt, nếu createAt bằng nhau -> check theo passportId và passportLevel
    // console.log("this.parseDateStr(a.startAt)", this.parseDateStr(a.startAt))
    // const dateA = this.parseDateStr(a.startAt);
    // const dateA = this.parseDateStr(a.startAt);
    // // const dateB = this.parseDateStr(b.startAt);
    // const dateB = this.parseDateStr(b.startAt);

    if (a && b) {
      // console.log(moment(b, 'DD-MM-YYYY'));
      // console.log(moment(a, 'DD-MM-YYYY'));
      // console.log(moment(b, 'DD-MM-YYYY').isSame(moment(a, 'DD-MM-YYYY')));
      // if (moment(b, 'DD-MM-YYYY').isSame(moment(a, 'DD-MM-YYYY'))) {
      if (moment(b, 'DD-MM-YYYY').format('DD-MM-YYYY') === (moment(a, 'DD-MM-YYYY')).format('DD-MM-YYYY')) {
        if (a.passportId === b.passportId) {
          return b.passportLevel - a.passportLevel;
        }
        return b.passportId - a.passportId;
      }
      // @ts-ignore
      return new Date(moment(b, 'DD-MM-YYYY')) - new Date(moment(a, 'DD-MM-YYYY'));
    }
    // Nếu status không cùng loại, không so sánh
    return a.status - b.status;
  }

  parseDateStr(dateStr) {
    if (!dateStr) { return null; }
    // const [day, month, year] = dateStr.split('-');
    // console.log("day", day)
    // console.log("month", month)
    // console.log("year", year)
    // @ts-ignore
    return new Date(moment(dateStr, 'DD-MM-YYYY'));
  }

  loadData() {
    if (!this.productDetail) return;
    this.productsService.getProductPassport(this.productDetail.userId, this.productId).subscribe(res => {
      if (res && res.code === 1 && res.data) {
        this.detail = res.data;
        // if (this.detail && this.detail.passports && this.detail.passports.length) {
          // this.detail.passports.sort(this.compare);
          // const passports = [...this.detail.passports];
          // console.log(passports.sort(this.compare));
          // console.log("data.sort(compare) xxxxxxxx", this.detail.passports.sort(this.compare))

          // console.log("ttttt", ttttt)
        // }
      }
    });
  }

  onActivePassport(passport, index) {
    this.activePassport = index;
    this.passport = passport;
    this.loadPassportDocument();
  }
  isAdminApprove = false;

  loadPassport() {
    this.productsService.getPassports({
      page: 1,
      pageSize: 1000,
      status: 1
    }).subscribe(res => {
      if (res && res.code === 1) {
        this.passports = res && res.data ? res.data.sort((a, b) => {
          // b.passportLevel - a.passportLevel
          if (a.id === b.id) {
            return a.level - b.level;
          }
          return a.id - b.id;
        }) : [];
        if (res.data && res.data.length) {
          this.passport = this.passports[0];
          this.loadPassportDocument();
          this.activePassport = 0;
        }
      }
    });
  }

  loadPassportDocument() {
    this.loading = true;
    this.isAdminApprove = false;
    const passport = this.passport;
    if (this.detail && this.detail.passports && this.detail.passports.length) {
      // console.log('xxx')
      const dataPassport = this.detail.passports.filter(item => item.passportId === passport.id);
      if (dataPassport && dataPassport.length && (dataPassport[0].passportSource === 'TEMP' || dataPassport[0].passportSource === 'ADMIN')) {
        // alert('tiêu chuẩn này do admin duyệt')
        this.isAdminApprove = true;
        this.loading = false;
      } else {
        this.fetchPassportByDocument();
      }
    } else {
      this.fetchPassportByDocument();
    }
  }

  fetchPassportByDocument() {
    if (!this.productDetail) { return; }
    this.productsService.getPassportByDocument(this.productDetail.userId, this.productId, {passportId: this.passport.id}).subscribe(res => {
      if (res && res.code === 1) {
        this.listPassportDocument = res && res.data ? res.data.map((item, index) => {
          return {
            ...item,
            stt: index + 1,
            documentUrls: item && item.documentUrl && item.documentUrl.length ? item.documentUrl.replace('{', '').replace('}', '').split(',') : []
          };
        }) : [];
      }
    });
  }

  getStatusText(expiredAt) {
    if (!expiredAt) { return ''; }
    if (moment().isAfter(moment(expiredAt, 'DD-MM-YYYY'))) {
      return 'Hết hạn';
    }

    if (moment().isSameOrBefore(moment(expiredAt, 'DD-MM-YYYY'))) {
      return 'Còn hạn';
    }
  }

  onNavToAddDocument() {
    return this.router.navigate([`/business/products/${this.productId}/documents`]);
  }
  onNavToList() {
    return this.router.navigate([`/business/products`]);
  }

  getLabelPassport(item) {
    const start  = item.startAt;
    const end  = item.end;
    const status  = item.status;
    const passportSource  = item.passportSource;
    // console.log("item", item)
    if (status === 1) {
      if (passportSource === 'TEMP' && ((moment(end, 'DD-MM-YYYY').startOf('day')).diff(moment().startOf('day'), 'days') > 7 || !end)) {
        return 'Tạm thời';
      }

      if ((passportSource === 'ADMIN' || passportSource === 'AUTO') && ((moment(end, 'DD-MM-YYYY').startOf('day')).diff(moment().startOf('day'), 'days') > 7 || !end)) {
        return 'Đạt chuẩn';
      }
      // console.log((moment(end, 'DD-MM-YYYY').startOf('day')).diff(moment().startOf('day')))
      // if (moment().startOf('day').isSameOrAfter(moment(start, 'DD-MM-YYYY').startOf('day')) && moment().startOf('day').isSameOrBefore(moment(end, 'DD-MM-YYYY').startOf('day')) && (moment(end, 'DD-MM-YYYY').startOf('day')).diff(moment().startOf('day'), 'days') > 7) {
      //   console.log("1")
      //   return 'Đạt chuẩn'
      // }
      //
      if ((moment(end, 'DD-MM-YYYY').startOf('day')).diff(moment().startOf('day'), 'days') <= 7 && (moment(end, 'DD-MM-YYYY').startOf('day')).diff(moment().startOf('day'), 'days') > 0) {
        console.log("2");
        return 'Sắp hết hạn';
      }

      // if (moment().startOf('day').isSameOrAfter(moment(end, 'DD-MM-YYYY').startOf('day'))) {
      //   console.log("3")
      //   return 'Hết hạn'
      // }

      if (!end) {
        return 'Đạt chuẩn';
      }
    } else {
      if (status === 3) {
        return 'Hủy bỏ';
      }
      if (status === 2) {
        return 'Hết hạn';
      }
      // return 'Không đạt chuẩn'
    }
    // console.log("passportSource", passportSource)
    // if (passportSource !== 'AUTO') {
    //   return 'Tạm thời'
    // } else {
    //   console.log((moment(end, 'DD-MM-YYYY').startOf('day')).diff(moment().startOf('day')))
    //   if (moment().startOf('day').isSameOrAfter(moment(start, 'DD-MM-YYYY').startOf('day')) && moment().startOf('day').isSameOrBefore(moment(end, 'DD-MM-YYYY').startOf('day')) && (moment(end, 'DD-MM-YYYY').startOf('day')).diff(moment().startOf('day'), 'days') > 7) {
    //     // console.log("1")
    //     return 'Đạt chuẩn'
    //   }
    //
    //   if ((moment(end, 'DD-MM-YYYY').startOf('day')).diff(moment().startOf('day'), 'days') <= 7 && (moment(end, 'DD-MM-YYYY').startOf('day')).diff(moment().startOf('day'), 'days') > 0) {
    //     console.log("2")
    //     return 'Sắp hết hạn'
    //   }
    //
    //   if (moment().startOf('day').isSameOrAfter(moment(end, 'DD-MM-YYYY').startOf('day'))) {
    //     console.log("3")
    //     return 'Hết hạn'
    //   }
    //
    //   if (!end) {
    //     return 'Đạt chuẩn'
    //   }
    // }

    // return 'Đạt chuẩn'
  }


  // onAddDocument() {
  //   this.router.navigate([`business/products/${this.productId}/documents`]);
  //   this.modalRef.close();
  // }

}
